export default __webpack_public_path__ + "static/media/description.77c9f9dd.svg";